import './Tag.scss'

export interface ITagProps {
  text: string
  type?: 'primary' | 'secondary' | 'default'
}

export default function Tag ({ text, type = 'default' }: ITagProps) {

  return (
    <div className={`tag tag--${type}`}>
      {text}
    </div>
  )
}
